import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { initialState } from '../common/constants'
import { rootReducer } from './rootReducer'
import {gaEvents} from './middlewares'

export const store = createStore(rootReducer, initialState, applyMiddleware(thunk, gaEvents))
